import { render, staticRenderFns } from "./baseInfo.vue?vue&type=template&id=0542a55a"
import script from "./baseInfo.vue?vue&type=script&lang=js"
export * from "./baseInfo.vue?vue&type=script&lang=js"
import style0 from "./baseInfo.vue?vue&type=style&index=0&id=0542a55a&prod&lang=scss"
import style1 from "./baseInfo.vue?vue&type=style&index=1&id=0542a55a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports